export const patientFullName = (patient: { title: string; lastName: string; firstName: string }) => {
  const titleLastName = `${patient.title} ${patient.lastName}`.trim();
  return [titleLastName, patient.firstName].join(', ').trim();
};
